import { render } from "./PointHistories.vue?vue&type=template&id=0779f481&scoped=true"
import script from "./PointHistories.vue?vue&type=script&lang=js"
export * from "./PointHistories.vue?vue&type=script&lang=js"

import "./PointHistories.vue?vue&type=style&index=0&id=0779f481&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0779f481"]])

export default __exports__